import { AUDITOR, CONTRACTOR, GUEST, PROGRAM_ADMIN } from "utils/constants/UserRoles";
import { setOnboarding, setOnboardingBackUrl } from "../../redux/reducers/companySlice";
export const getProgramRoleOptions = (companyRole, roles) => {
	const programRoles = roles?.filter((role) => role.type === "program");
	let options = [];
	switch (companyRole) {
		case AUDITOR:
			options = programRoles?.filter((role) => role.name === PROGRAM_ADMIN);
			break;
		case CONTRACTOR:
			options = programRoles?.filter((role) => role.name === PROGRAM_ADMIN || role.name === AUDITOR);
			break;
		case GUEST:
			options = programRoles?.filter((role) => role.name !== GUEST);
			break;
		default:
			options = programRoles;
	}
	return options;
};

export const findRole = (roles, roleId) => {
	return roles?.find((role) => role.id === roleId);
};

/**
 * Completes the onboarding process by updating the state and navigating to the next URL.
 *
 * @param {Function} dispatch - The dispatch function to update the Redux store.
 * @param {string} backUrl - The URL to store as the back navigation URL.
 * @param {Function} navigate - The function to navigate to a different route.
 * @param {string} nextUrl - The URL to navigate to after completing onboarding.
 */
export const completeOnboarding = (dispatch, backUrl, navigate, nextUrl) => {
	dispatch(setOnboarding(true));
	dispatch(setOnboardingBackUrl(backUrl));
	navigate(nextUrl);
};

export const initialOnboardingStatus = { percent: 0, show: false, onboardingStep: 0 };
